import _extends from '@babel/runtime/helpers/extends';
import { makeStyles, theme, customArcherColors, LayoutGrid, Link, Icon } from '@archer-technologies/ui-components';
import { DataTypeProvider } from '@devexpress/dx-react-grid';
import { createElement } from 'react';
var useStyles = makeStyles({
  statusLink: {
    fontSize: '0.875rem',
    fontFamily: 'Lato,Roboto,"Helvetica Neue",Arial,sans-serif'
  },
  statusIconRoot: {
    color: function color(props) {
      return props.iconColor ? props.iconColor : theme.palette.primary.main;
    },
    display: 'block',
    margin: '0 auto'
  },
  statusIconOnly: {
    textAlign: 'center'
  },
  statusText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }
});

var StatusFormatter = function StatusFormatter(_ref) {
  var value = _ref.value;
  var statusIcon = value.statusIcon,
      statusLabel = value.statusLabel,
      onClick = value.onClick,
      iconOnly = value.iconOnly,
      isNavigation = value.isNavigation;
  var statusColor = customArcherColors.getCustomStatusIconColors(statusIcon);
  var statusStylingProps = {
    iconColor: statusColor
  };

  var _useStyles = useStyles(statusStylingProps),
      statusIconRoot = _useStyles.statusIconRoot,
      statusIconOnly = _useStyles.statusIconOnly,
      statusLink = _useStyles.statusLink,
      statusText = _useStyles.statusText;

  var linkProps = {
    className: statusLink,
    component: isNavigation ? 'a' : 'button'
  };
  var iconProps = iconOnly ? {
    titleAccess: statusLabel ? statusLabel : statusIcon
  } : {};
  var iconGridSize = !iconOnly ? 2 : 12;
  return value ? /*#__PURE__*/createElement(LayoutGrid, {
    container: true
  }, statusLabel && !iconOnly && /*#__PURE__*/createElement(LayoutGrid, {
    item: true,
    xs: true,
    className: statusText
  }, onClick ? /*#__PURE__*/createElement(Link, _extends({
    onClick: onClick
  }, linkProps), statusLabel) : statusLabel), statusIcon && /*#__PURE__*/createElement(LayoutGrid, {
    item: true,
    xs: iconGridSize
  }, /*#__PURE__*/createElement(Icon, _extends({
    icon: statusIcon,
    fontSize: "medium",
    className: "".concat(statusIconRoot, " ").concat(statusIconOnly)
  }, iconProps))), !statusIcon && !statusLabel && /*#__PURE__*/createElement(LayoutGrid, {
    item: true,
    xs: iconGridSize
  }, "--")) : null;
};

var StatusTypeProvider = function StatusTypeProvider(props) {
  return /*#__PURE__*/createElement(DataTypeProvider, _extends({
    formatterComponent: StatusFormatter
  }, props));
};

export { StatusFormatter, StatusTypeProvider };